'use client'
import { useEffect, useState } from 'react'
import TestimonialsSection from './TestimonialsSection'

interface TestimonialData {
  id: number;
  name: string;
  job_position: string;
  company: string;
  description: string;
  logo: string;
}

export default function TestimonialsClient() {
  const [data, setData] = useState<TestimonialData[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('/api/testimonials')
      .then(res => res.json())
      .then(json => {
        setData(Array.isArray(json) ? json : [])
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false))
  }, [])

  return <TestimonialsSection data-component-id="src\components\common\TestimonialsClient.tsx:28:9" data-component-path="src\components\common\TestimonialsClient.tsx" data-component-line="28" data-component-end-line="28" data-component-file="TestimonialsClient.tsx" data-component-name="TestimonialsSection" data-component-content="%7B%22elementName%22%3A%22TestimonialsSection%22%7D" testimonials={data} loading={loading} />
}
